import React from "react";
import { Link } from "react-router-dom";
import { logout } from "../../Utils/Auth";

let AdminHeader = () => {
  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white">
        <ul className="navbar-nav">
          <li className="nav-item">
            <Link
              to="#"
              className="nav-link"
              data-widget="pushmenu"
              role="button"
            >
              <i className="fas fa-bars custom-text-primary"></i>
            </Link>
          </li>
        </ul>

        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown">
            <Link to="#" className="nav-link" data-toggle="dropdown">
              <img
                src={require("../../Assets/Images/username.png")}
                alt="N/A"
                height="25"
              />{" "}
              <b className="custom-text-primary">
                {localStorage.getItem("user_type") == 1
                  ? localStorage.getItem("first_name") //+ " Admin" 
                  : localStorage.getItem("user_type") == 4
                  ? localStorage.getItem("first_name")  //+ " Sub admin" 
                  : localStorage.getItem("user_type") == 5
                  ? localStorage.getItem("first_name")  //+ " Quality supervisor" 
                  : ""}
              </b>
            </Link>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              <div className="dropdown-divider" />
              <Link to="#" className="dropdown-item" onClick={logout}>
                <i className="fa fa-arrow-circle-o-right  mr-2" /> Logout
              </Link>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default AdminHeader;
